import { useQuery } from '@tanstack/react-query';
import {
  accountQuery,
  playerProfileQuery,
  profileDisplayName,
  profileInitials,
  useAuthSession,
} from '@/api';
import { cn } from '@/lib/cn';
import { MenuBalanceCard } from '@/shell/MenuBalanceCard';
import { AccountNav } from './AccountNav';
import { AccountPlayerCard } from './AccountPlayerCard';
import { profileNavItems } from './profileNav';

export interface AccountMenuProps {
  className?: string;
}

/** Mobile full-width account menu (Figma Mobile / Account Menu). */
export function AccountMenu({ className }: AccountMenuProps) {
  const { user } = useAuthSession();
  const { data: account } = useQuery(accountQuery());
  const machineGuid = user?.Guid ?? null;
  const { data: profile } = useQuery(playerProfileQuery(machineGuid));

  const source = profile ?? {
    FirstName: undefined,
    LastName: undefined,
    Username: user?.Username ?? user?.Name,
  };
  const displayName = profileDisplayName(source) || user?.Name || user?.Username || '';
  const username = profile?.Username ?? user?.Username ?? '';
  const initials = profileInitials(source);
  const items = profileNavItems(account, user);

  return (
    <div className={cn('flex w-full flex-col gap-3', className)}>
      <AccountPlayerCard displayName={displayName} username={username} initials={initials} />
      <MenuBalanceCard />
      <AccountNav items={items} />
    </div>
  );
}
